//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ModalOption from '~/components/ochki/ModalOption.vue';

export default {

  data: function () {
    return {
      lenses: [],

      activeProductId: null,
      activeProductOptionsIds: [],

      openOption: {}

    }
  },

  props: {

    product: {
      type: Object,
      default: () => {
        return {}
      }
    }

  },

  computed: {

    productOptions: function() {
      return this.lenses.find((t) => t.id === this.activeProductId)?.options || [];
    },

    totalPrice: function () {
      const product = this.lenses.find((t) => t.id === this.activeProductId);
      const activeOptions = (product?.options || [])?.filter((t) => this.activeProductOptionsIds.includes(t.id));
      const totalProceOptions = activeOptions.reduce((value, option) => {
        return value + option.price;
      }, 0);

      return (this.product?.price || 0) + (product?.price || 0) + (totalProceOptions || 0)
    }

  },

  components: {
    ModalOption
  },

  mounted: async function () {

    await this.getProducts();

  },

  methods: {

    getProducts: async function () {

      const { data: lenses } = await this.$api.agent.transport.get(`lens?filter[filter_page_id]=94&expand=options`);

      this.lenses = lenses;

      this.onChangeProduct(lenses?.[0]?.id || '')

    },

    onChangeProduct: function(productId) {
      this.activeProductId = productId;
      this.activeProductOptionsIds = [];
    },
    onChangeOptions: function(optionId) {
      let newActiveProductOptionsIds = [...this.activeProductOptionsIds];

      const indexOption = newActiveProductOptionsIds.findIndex((t) => t === optionId);

      if (indexOption <= -1) {
        newActiveProductOptionsIds.push(optionId);
      }
      else {
        newActiveProductOptionsIds.splice(indexOption, 1);
      }

      this.activeProductOptionsIds = newActiveProductOptionsIds;
    },

    isActiveOption: function(optionId) {
      const product = this.lenses.find((t) => t.id === this.activeProductId);
      const options = product?.options || [];
      const activeOptions = this.activeProductOptionsIds;

      let isActive = true;

      if (activeOptions.length <= 0) {
        return isActive;
      }

      activeOptions.map((id) => {
        if ((options.find((t) => t.id === id)?.exclusions_ids || []).includes(optionId)) {
          isActive = false;
        }
      });

      return isActive;
    }

  }

};
